/** @format */

module.exports = {
	newChallenge: "Novo desafio!",
	instructions:
		"Você tem uma missão especial esperando você! Aceitando fazer a missão especial, caso você acerte todas atividades, você ganhará duas moedas extras e o dobro de pontos. Mas cuidado, se você errar ao menos uma atividade, não ganhará nada com essa missão.",
	accept: "Eu aceito o desafio!",
	deny: "Não quero.",
};
